import React, { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import ArrowsImage from 'asset/ship-dates/Arrows.png';
import AprilImage from 'asset/ship-dates/April.png';
import MayImage from 'asset/ship-dates/May.png';
import JuneImage from 'asset/ship-dates/June.png';
import JulyImage from 'asset/ship-dates/July.png';
import AugustImage from 'asset/ship-dates/August.png';
import SeptemberImage from 'asset/ship-dates/September.png';
import OctoberImage from 'asset/ship-dates/October.png';
import NovemberImage from 'asset/ship-dates/November.png';
import DecemberImage from 'asset/ship-dates/December.png';

interface MonthConfig {
    name: string;
    image: string;
    tag: string;
}

const months: MonthConfig[] = [
    { name: 'April', image: AprilImage, tag: 'APRIL' },
    { name: 'May', image: MayImage, tag: 'MAY' },
    { name: 'June', image: JuneImage, tag: 'JUNE' },
    { name: 'July', image: JulyImage, tag: 'JULY' },
    { name: 'August', image: AugustImage, tag: 'AUGUST' },
    { name: 'September', image: SeptemberImage, tag: 'SEPTEMBER' },
    { name: 'October', image: OctoberImage, tag: 'OCTOBER' },
    { name: 'November', image: NovemberImage, tag: 'NOVEMBER' },
    { name: 'December', image: DecemberImage, tag: 'DECEMBER' },
];

interface ShipDatesProps {
    onSelect?: () => void;
}

export const ShipDates: React.FC<ShipDatesProps> = ({ onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleMonthClick = (tag: string) => {
        navigate({ to: '/order', search: { tag } });
        if (onSelect) {
            onSelect();
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.monthsGrid}>
                {months.map((month) => (
                    <div
                        key={month.name}
                        style={styles.monthItem}
                        onClick={() => handleMonthClick(month.tag)}
                    >
                        <img
                            src={month.image}
                            alt={month.name}
                            style={styles.monthImage}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    container: {
        position: 'relative',
        display: 'inline-block',
        border: '2px solid #FF0098',
        padding: '20px',
    },
    arrow: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'transform 0.3s ease',
        padding: '10px',
    },
    arrowImage: {
        width: '60px',
        height: 'auto',
    },
    monthsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '15px',
        maxWidth: '600px',
    },
    monthItem: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'transform 0.2s ease, opacity 0.2s ease',
    },
    monthImage: {
        width: '100%',
        maxWidth: '150px',
        height: 'auto',
    },
};
